import React, { useRef, useState } from 'react';
import { ORIGIN_STORY } from '../data';

export default function OriginStory() {
  const trackRef = useRef(null);
  const [hovered, setHovered] = useState(null);

  const scroll = (dir) => {
    if (trackRef.current) trackRef.current.scrollBy({ left: dir * 380, behavior: 'smooth' });
  };

  return (
    <section id="story" style={{ padding: '120px 0', background: 'var(--bg)' }}>
      {/* Header */}
      <div className="fade-in" style={{ padding: '0 12%', marginBottom: '64px' }}>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.3em', color: 'var(--ink-light)', textTransform: 'uppercase', marginBottom: '16px' }}>
          Origin Story
        </div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 1, letterSpacing: '-0.03em' }}>
          The Arc
        </h2>
      </div>

      {/* Scroll controls */}
      <div style={{ padding: '0 12%', marginBottom: '32px', display: 'flex', gap: '12px' }}>
        <button onClick={() => scroll(-1)} style={{ fontFamily: 'var(--font-mono)', fontSize: '16px', color: 'var(--ink-mid)', background: 'none', border: '1px solid rgba(26,26,26,0.15)', width: '40px', height: '40px', cursor: 'crosshair', transition: 'all 0.2s' }}
          onMouseEnter={e => { e.target.style.background = 'var(--ink)'; e.target.style.color = 'var(--bg)'; }}
          onMouseLeave={e => { e.target.style.background = 'none'; e.target.style.color = 'var(--ink-mid)'; }}
        >←</button>
        <button onClick={() => scroll(1)} style={{ fontFamily: 'var(--font-mono)', fontSize: '16px', color: 'var(--ink-mid)', background: 'none', border: '1px solid rgba(26,26,26,0.15)', width: '40px', height: '40px', cursor: 'crosshair', transition: 'all 0.2s' }}
          onMouseEnter={e => { e.target.style.background = 'var(--ink)'; e.target.style.color = 'var(--bg)'; }}
          onMouseLeave={e => { e.target.style.background = 'none'; e.target.style.color = 'var(--ink-mid)'; }}
        >→</button>
      </div>

      {/* Horizontal scroll track */}
      <div ref={trackRef} style={{
        display: 'flex', gap: '0', overflowX: 'auto', overflowY: 'hidden',
        scrollbarWidth: 'none', paddingLeft: '12%', paddingRight: '12%',
        scrollSnapType: 'x mandatory',
      }}>
        {ORIGIN_STORY.map((chapter, idx) => {
          const active = hovered === idx;
          return (
          <div key={chapter.id}
            onMouseEnter={() => setHovered(idx)}
            onMouseLeave={() => setHovered(null)}
            style={{
            minWidth: '340px', maxWidth: '340px',
            borderRight: '1px solid rgba(26,26,26,0.08)',
            padding: '40px 36px',
            scrollSnapAlign: 'start',
            background: active ? 'var(--ink)' : 'transparent',
            position: 'relative', flexShrink: 0,
            transition: 'background 0.3s ease, color 0.3s ease',
          }}>
            {/* Chapter number */}
            <div style={{
              fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.3em',
              color: active ? 'var(--accent)' : 'var(--ink-light)',
              textTransform: 'uppercase', marginBottom: '24px',
              transition: 'color 0.3s ease',
            }}>Ch. {chapter.chapter}</div>

            {/* Title */}
            <h3 style={{
              fontFamily: 'var(--font-display)', fontSize: '32px', fontWeight: 600,
              color: active ? '#fafaf8' : 'var(--ink)',
              lineHeight: 1, marginBottom: '8px', letterSpacing: '-0.02em',
              transition: 'color 0.3s ease',
            }}>{chapter.title}</h3>

            {/* Years + location */}
            <div style={{
              fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em',
              color: active ? 'rgba(250,250,248,0.4)' : 'var(--ink-light)',
              marginBottom: '32px', textTransform: 'uppercase',
              transition: 'color 0.3s ease',
            }}>
              {chapter.years} · {chapter.location}
            </div>

            {/* Accent line */}
            <div style={{
              width: '32px', height: '2px',
              background: active ? 'var(--accent)' : 'var(--ink)',
              marginBottom: '28px', opacity: 0.4,
              transition: 'background 0.3s ease',
            }} />

            {/* Items */}
            {chapter.items.map((item, i) => (
              <div key={i} style={{
                fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 300,
                color: active ? 'rgba(250,250,248,0.65)' : 'var(--ink-mid)',
                lineHeight: 1.7, marginBottom: '6px',
                paddingLeft: '14px', borderLeft: `1px solid ${active ? 'rgba(232,197,71,0.3)' : 'rgba(26,26,26,0.12)'}`,
                transition: 'color 0.3s ease, border-color 0.3s ease',
              }}>{item}</div>
            ))}
          </div>
          );
        })}
      </div>
    </section>
  );
}
